module.exports = __webpack_public_path__ + "img/parallax-text-column-right.436abaa6.svg";